import { VenueSurchargesType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueSurchargesTableRow } from './components';
import { venueSurchargesRows } from './data';

type VenueSurchargesTablePropsType = {
  venueSurcharges: VenueSurchargesType;
};

export const VenueSurchargesTable: React.FC<VenueSurchargesTablePropsType> = ({
  venueSurcharges,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueSurchargesRows.map((row) => (
          <VenueSurchargesTableRow
            key={row.label}
            venueSurcharges={venueSurcharges}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

